import LogicalOperator from "../../consts/DataSourceModule/LogicalOperator";
import FilterParameterDto from "./FilterParameterDto";

class GroupFilterDto {
    Id: number;
    Operator: LogicalOperator;
    Childrens: GroupFilterDto[];
    Parameters: FilterParameterDto[];

    constructor(id: number, operator: LogicalOperator, childrens: GroupFilterDto[], parameters: FilterParameterDto[]) {
        this.Id = id;
        this.Operator = operator;
        this.Childrens = childrens;
        this.Parameters = parameters;
    }
}

export default GroupFilterDto;
